<template>
    <svg :viewBox="symbolData.viewBox">
        <use :xlink:href="symbolData.url"></use>
    </svg>
</template>
<script lang="ts">
import {SvgSymbolData} from '@/icons/index';
import {defineComponent, PropType} from 'vue';

export default defineComponent({
    props: {
        symbolData: {
            type: Object as PropType<SvgSymbolData>,
            required: true,
        },
    },
    setup() {
        // No logic needed — props are used directly in template
    },
});
</script>
